import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { fetchMaintenanceById, updateMaintenance } from '../reducers/MaintenanceSlice';
import { toast } from 'react-toastify';
import { fetchHistoryById, updateHistory } from '../reducers/HistorySlice';
const UpdateHistory = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { history, status } = useSelector(state => state.histories);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        students: '',
        securityCharges: '',
        paidAmount: '',
        receivedAmount: '',
        month: '',
        bookings: '',
        staff: '',
        workers: '',
        staffSalary: '',
        workerSalary: '',
        totalSalary: '',
        maintenanceCost: '',
        electricityBill: '',
        waterBill: '',
        gasBill: '',
        internetBill: '',
        otherBills: '',
    });

    useEffect(() => {
        if (id) {
            dispatch(fetchHistoryById(id));
        }
    }, [id, dispatch]);
    useEffect(() => {
        if (history) {
            setFormData({
                students: history.students || '',
                securityCharges: history.securityCharges || '',
                paidAmount: history.paidAmount || '',
                receivedAmount: history.receivedAmount || '',
                month: history.month || '',
                bookings: history.bookings || '',
                staff: history.staff || '',
                workers: history.workers || '',
                staffSalary: history.staffSalary || '',
                workerSalary: history.workerSalary || '',
                totalSalary: history.totalSalary || '',
                maintenanceCost: history.maintenanceCost || '',
                electricityBill: history.electricityBill || '',
                waterBill: history.waterBill || '',
                gasBill: history.gasBill || '',
                internetBill: history.internetBill || '',
                otherBills: history.otherBills || '',
            });
        }
    }, [history]);

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await dispatch(updateHistory({ id: id, historyData: formData })).unwrap();

            if (response) {
                toast.success('History has been updated!');
                navigate('/histories');
            } else {
                toast.error('An error occurred while updating the history.');
            }
        } catch (error) {
            toast.error('Update failed!');
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div className="container mt-4 text-white">
                <h2 className="mb-4 text-center">Update Monthly Records</h2>
                <form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                        {[
                            { id: 'students', label: 'Students', type: 'number' },
                            { id: 'bookings', label: 'Bookings', type: 'number' },
                            { id: 'month', label: 'Month', type: 'text', placeholder: 'e.g., April 2025' },
                            { id: 'staff', label: 'Staff', type: 'number' },
                            { id: 'workers', label: 'Workers', type: 'number' },
                            { id: 'staffSalary', label: 'Staff Salary', type: 'number' },
                            { id: 'workerSalary', label: 'Worker Salary', type: 'number' },
                            { id: 'totalSalary', label: 'Total Salary', type: 'number' },
                            { id: 'securityCharges', label: 'Security Charges', type: 'number' },
                            { id: 'maintenanceCost', label: 'Maintenance Cost', type: 'number' },
                            { id: 'paidAmount', label: 'Paid Amount', type: 'number' },
                            { id: 'receivedAmount', label: 'Received Amount', type: 'number' },
                            { id: 'electricityBill', label: 'Electricity Bill', type: 'number' },
                            { id: 'waterBill', label: 'Water Bill', type: 'number' },
                            { id: 'gasBill', label: 'Gas Bill', type: 'number' },
                            { id: 'internetBill', label: 'Internet Bill', type: 'number' },
                            { id: 'otherBills', label: 'Other Bills', type: 'number' },
                        ].map(({ id, label, type, placeholder }) => (
                            <div key={id} className="col-md-4 mb-3">
                                <label htmlFor={id} className="form-label">{label}</label>
                                <input
                                    type={type}
                                    className="form-control"
                                    id={id}
                                    value={formData[id]}
                                    onChange={handleInputChange}
                                    placeholder={placeholder || ''}
                                />
                            </div>
                        ))}
                    </div>

                    <div className="text-end">
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Updating...' : 'Save History'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default UpdateHistory
